import { render, staticRenderFns } from "./contact-relationship-table.vue?vue&type=template&id=38f253dc&scoped=true&lang=pug&"
import script from "./contact-relationship-table.vue?vue&type=script&lang=ts&"
export * from "./contact-relationship-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f253dc",
  null
  
)

export default component.exports